// extracted by mini-css-extract-plugin
export var printerCard = "_aq-1";
export var printerCardConfigured = "_aq-2";
export var printerCardError = "_aq-3";
export var printerCardsContainer = "_aq-0";
export var printerIcon = "_aq-8";
export var printerIconConfigured = "_aq-5";
export var printerIconContainer = "_aq-4";
export var printerIconError = "_aq-6";
export var printerIconUnconfigured = "_aq-7";
export var workstationsTableCard = "_aq-9";